import React from "react";
import { StyleSheet, View, Text, TouchableOpacity, Image } from "react-native";
import { colors } from "src/assets";

export type ImageCarouselIndexProps = {
  index: number;
};

export const ImageCarouselIndex: React.FC<ImageCarouselIndexProps> = ({
  index,
}) => {
  return (
    <View style={indexStyles.container}>
      <Text style={indexStyles.text}>{index}</Text>
    </View>
  );
};

const indexStyles = StyleSheet.create({
  container: {
    width: 24,
    height: 24,
    backgroundColor: "#71D6C9",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    fontSize: 14,
    fontWeight: "500",
    color: colors.white,
  },
});

export type ImageCarouselImageProps = {
  image: string;
  index: number;
  onDelete?: () => void;
};

export const ImageCarouselImage: React.FC<ImageCarouselImageProps> = ({
  image,
  index,
  onDelete,
}) => {
  return (
    <View style={styles.container}>
      <Image
        source={{
          uri: image,
        }}
        style={imageStyles.image}
        resizeMode="cover"
      />
      <View style={styles.indexContainer}>
        <ImageCarouselIndex index={index} />
      </View>
      <TouchableOpacity style={imageStyles.delete} onPress={onDelete}>
        <svg width="18" height="20.435" viewBox="0 0 18 20.435">
          <path
            d="M8.994,20.435h-4.3a2.467,2.467,0,0,1-2.446-2.277C1.941,16.245,1.136,8.006.973,6.322A1.7,1.7,0,0,1,0,4.788V4.445A1.7,1.7,0,0,1,1.695,2.75H6.268V1.116A1.105,1.105,0,0,1,7.359,0h3.282a1.1,1.1,0,0,1,1.091,1.116V2.75h4.573A1.7,1.7,0,0,1,18,4.445v.344a1.7,1.7,0,0,1-1,1.547c-.164,1.735-.957,10.05-1.273,11.828a2.466,2.466,0,0,1-2.445,2.27ZM3.56,17.964c0,.013,0,.026.005.039a1.148,1.148,0,0,0,1.127,1.1h8.586A1.148,1.148,0,0,0,14.406,18c0-.017,0-.034.007-.051.287-1.576,1.029-9.286,1.237-11.468H2.322C2.533,8.648,3.281,16.239,3.56,17.964ZM1.327,4.445v.344a.368.368,0,0,0,.368.368h14.61a.368.368,0,0,0,.368-.368V4.445a.368.368,0,0,0-.368-.368H1.695A.368.368,0,0,0,1.327,4.445ZM10.405,2.75V1.327H7.595V2.75ZM12,17.531a.664.664,0,0,1-.623-.7l.487-8.18a.664.664,0,0,1,1.325.079l-.488,8.18a.664.664,0,0,1-.662.624Zm-3.666-.663V8.688a.664.664,0,1,1,1.327,0v8.18a.664.664,0,1,1-1.327,0Zm-3.041.04-.488-8.18a.664.664,0,0,1,1.325-.079l.488,8.18a.664.664,0,0,1-.623.7h-.04A.664.664,0,0,1,5.3,16.908Z"
            fill="#ff3000"
          />
        </svg>
      </TouchableOpacity>
    </View>
  );
};

const imageStyles = StyleSheet.create({
  delete: {
    position: "absolute",
    right: 8,
    bottom: 8,
    borderRadius: 20,
    width: 40,
    height: 40,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.white,
  },
  image: {
    width: 190,
    height: 140,
  },
});

export type ImageCarouselAddProps = {
  index: number;
  onPress?: () => void;
};

export const ImageCarouselAdd: React.FC<ImageCarouselAddProps> = ({
  index,
  onPress,
}) => {
  return (
    <TouchableOpacity
      style={[styles.container, addStyles.container]}
      onPress={onPress}
    >
      <svg width="40" height="32.107" viewBox="0 0 40 32.107">
        <path
          d="M4.934,32.107A4.939,4.939,0,0,1,0,27.173V9.652A4.939,4.939,0,0,1,4.934,4.718h5.11c.33-.481.682-1.061,1-1.59a14.788,14.788,0,0,1,1.026-1.564C13.378,0,14.668,0,17.239,0h5.522c2.571,0,3.862,0,5.166,1.564a14.778,14.778,0,0,1,1.026,1.564c.322.529.674,1.109,1,1.59h5.11A4.94,4.94,0,0,1,40,9.652V27.173a4.94,4.94,0,0,1-4.934,4.934ZM2.819,9.652V27.173a2.117,2.117,0,0,0,2.115,2.114H35.066a2.117,2.117,0,0,0,2.114-2.114V9.652a2.117,2.117,0,0,0-2.114-2.115H29.244a1.411,1.411,0,0,1-1.1-.526,24.255,24.255,0,0,1-1.6-2.418c-.285-.468-.639-1.05-.783-1.224-.406-.487-.458-.55-3-.55H17.239c-2.541,0-2.593.063-3,.55-.145.174-.5.756-.783,1.224a24.173,24.173,0,0,1-1.6,2.418,1.411,1.411,0,0,1-1.1.526H4.934A2.117,2.117,0,0,0,2.819,9.652Zm8.194,7.806A8.987,8.987,0,1,1,20,26.444,9,9,0,0,1,11.013,17.458Zm2.819,0A6.167,6.167,0,1,0,20,11.29,6.174,6.174,0,0,0,13.833,17.458Zm15.086-6.652a1.467,1.467,0,1,1,1.467,1.467A1.467,1.467,0,0,1,28.918,10.806Z"
          fill="#b2b2b2"
        />
      </svg>
      <View style={styles.indexContainer}>
        <ImageCarouselIndex index={index} />
      </View>
    </TouchableOpacity>
  );
};

const addStyles = StyleSheet.create({
  container: {
    backgroundColor: colors.white,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});

const styles = StyleSheet.create({
  container: {
    width: 190,
    height: 140,
    marginHorizontal: 8,
  },
  indexContainer: {
    position: "absolute",
    left: 0,
    top: 0,
  },
});
